/* oxlint-disable */
import { css } from 'lit';

export default css`:host {
  display: block;
}

.progress {
  --progress--sizes: 5rem;
  --progress--color: var(--color-accent-600);
  --progress--color-secondary: var(--color-accent-200);
  --progress--color-text: var(--color-accent-700);
}
.progress.progress--size-M {
  --progress--sizes: 3.75rem;
}
.progress.progress--size-S {
  --progress--sizes: 2.5rem;
}
.is-dark .progress {
  --progress--color: var(--color-accent-100);
  --progress--color-secondary: var(--color-accent-500);
  --progress--color-text: var(--color-accent-100);
}

.progress {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.progress--type-circle {
  --progress--inner-sizes: 4rem;
  --progress--border: 0.375rem;
  --progress--margin: 0.5rem;
}
.progress--type-circle.progress--size-M {
  --progress--inner-sizes: 3rem;
  --progress--border: 0.25rem;
  --progress--margin: 0.0625rem;
}
.progress--type-circle.progress--size-S {
  --progress--inner-sizes: 2rem;
  --progress--border: 0.1875rem;
  --progress--margin: 0.0625rem;
}

.progress--type-circle {
  height: 100%;
}
.progress--type-circle .progress__item {
  width: var(--progress--sizes);
  height: var(--progress--sizes);
  display: flex;
  justify-content: center;
  align-items: center;
}
.progress--type-circle .progress__item:after {
  content: " ";
  display: block;
  width: var(--progress--inner-sizes);
  height: var(--progress--inner-sizes);
  margin: var(--progress--margin);
  border-radius: 50%;
  border-width: var(--progress--border);
  border-style: solid;
  border-color: var(--progress--color) var(--progress--color-secondary) var(--progress--color) var(--progress--color-secondary);
  animation: loading-animation 1.2s linear infinite;
  aspect-ratio: 1/1;
}

@keyframes loading-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.progress--type-text {
  --progress--text-size: 2rem;
}
.progress--type-text.progress--size-M {
  --progress--text-size: 1.5rem;
}
.progress--type-text.progress--size-S {
  --progress--text-size: 1rem;
}

.progress--type-text .progress__item {
  display: flex;
}
.progress--type-text .progress__item-char {
  font-size: var(--progress--text-size);
  color: var(--progress--color-text);
}
.progress--type-text .progress__item-char.column-even {
  animation: text-even-animation 0.65s linear infinite;
}
.progress--type-text .progress__item-char.column-odd {
  animation: text-odd-animation 0.65s linear infinite;
}

@keyframes text-even-animation {
  0% {
    transform: translateY(-0.0625rem);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-0.0625rem);
  }
}
@keyframes text-odd-animation {
  0% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-0.0625rem);
  }
  100% {
    transform: translateY(0);
  }
}
.progress--type-nyan-cat {
  --rainbow--line-color: #fff;
  --rainbow--line-height: 0.5rem;
  --rainbow--width: 7.5rem;
}
.progress--type-nyan-cat.progress--size-M {
  --rainbow--line-height: 0.375rem;
  --rainbow--width: 5.9375rem;
}
.progress--type-nyan-cat.progress--size-S {
  --rainbow--line-height: 0.25rem;
  --rainbow--width: 4.375rem;
}
.progress--type-nyan-cat .line-red {
  --rainbow--line-color: #ff0000;
}
.progress--type-nyan-cat .line-orange {
  --rainbow--line-color: #ff9900;
}
.progress--type-nyan-cat .line-yellow {
  --rainbow--line-color: #ffff00;
}
.progress--type-nyan-cat .line-green {
  --rainbow--line-color: #33ff00;
}
.progress--type-nyan-cat .line-blue {
  --rainbow--line-color: #0099ff;
}
.progress--type-nyan-cat .line-purple {
  --rainbow--line-color: #6633ff;
}
.progress--type-nyan-cat .line-marine {
  --rainbow--line-color: #0f4d8f;
}

.progress--type-nyan-cat {
  height: var(--progress--sizes);
  max-height: var(--progress--sizes);
}
.progress--type-nyan-cat img {
  height: 100%;
  aspect-ratio: 272/168;
  position: relative;
}
.progress--type-nyan-cat .progress__rainbow {
  display: flex;
  width: var(--rainbow--width);
  margin-right: -2.5rem;
  position: relative;
}
.progress--type-nyan-cat .progress__rainbow-column {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.progress--type-nyan-cat .progress__rainbow-column.column-even {
  animation: rainbow-even-animation 0.65s linear infinite;
}
.progress--type-nyan-cat .progress__rainbow-column.column-odd {
  animation: rainbow-odd-animation 0.65s linear infinite;
}
.progress--type-nyan-cat .progress__rainbow-line {
  height: var(--rainbow--line-height);
  background-color: var(--rainbow--line-color);
  width: 100%;
  opacity: 0.8;
}

@keyframes rainbow-even-animation {
  0% {
    transform: translateY(-0.25rem);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-0.25rem);
  }
}
@keyframes rainbow-odd-animation {
  0% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-0.25rem);
  }
  100% {
    transform: translateY(0);
  }
}
.progress--type-on-tracks {
  --progress-border: 0.375rem;
}
.progress--type-on-tracks.progress--size-M {
  --progress-border: 0.25rem;
}
.progress--type-on-tracks.progress--size-S {
  --progress-border: 0.125rem;
}

.progress--type-on-tracks {
  height: 100%;
}
.progress--type-on-tracks .progress__item {
  width: var(--progress--sizes);
  height: var(--progress--sizes);
  border: var(--progress-border) var(--progress--color) double;
  border-left-style: solid;
  border-right-style: solid;
  border-radius: 50%;
  animation: spinner-on-tracks 0.75s infinite linear;
}

@keyframes spinner-on-tracks {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .progress *,
  .progress *::before,
  .progress *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`;
